

























































































































































































































import axios from 'axios';
// eslint-disable-next-line
import { Component, Prop, Vue, Watch, } from 'vue-property-decorator';
import { TextLocalization } from '@/interfaces/TextLocalization';
import { WebDemoType } from '@/types/WebDemoType';
import { Language } from '@/types/Language';
import { FormErrors } from '@/interfaces/FormErrors';
import { UserFormData } from '@/interfaces/UserFormData';
import UITexts from '@/data/UITexts';

@Component({})
export default class FormComponent extends Vue {
  @Prop()
  isRequestingFormSubmit!: boolean

  @Prop()
  isTypForced!: boolean

  @Prop()
  isUserLogged!: boolean

  @Prop()
  webDemoType!: WebDemoType;

  @Prop()
  language!: Language;

  @Prop()
  userFormData!: UserFormData;

  @Prop()
  userEmail!: string;

  @Prop()
  isMobile!: boolean;

  $refs!: {
    form: HTMLFormElement;
  }

  form!: HTMLFormElement;

  isSending = false;

  isTypShown = false;

  isLunchTour = false;

  isThankYou = true;

  isErrorsShown = false;

  isFirstSend = true;

  errors: FormErrors | undefined;

  firstError = ''

  textLocalizations: TextLocalization[] = UITexts;

  webDemoId = 0

  product = '';

  leadComment = '';

  topicAction = '';

  contentStage = '';

  constructor() {
    super();
    this.resetErrors();
  }

  @Watch('isRequestingFormSubmit')
  onRequestChange(isRequestingFormSubmit: boolean) {
    if (isRequestingFormSubmit) {
      this.$emit('update:isRequestingFormSubmit', false);
      this.submit(this.$refs.form);
    }
  }

  @Watch('isTypForced')
  onTypForceChange(isTypForced: boolean) {
    if (isTypForced) {
      this.isTypShown = true;
    }
  }

  get classList(): string {
    const stepClass = this.isTypShown ? 'step2' : 'step1';
    return `progress-bar progress-bar-striped active ${stepClass}`;
  }

  get currentPageUrl(): string {
    // eslint-disable-next-line no-restricted-globals
    return `${location.protocol}//${location.host}${location.pathname}`;
  }

  submitForm() {
    this.submit(this.form);
  }

  setFirstError() {
    this.firstError = '';
    Object.entries(this.errors!).forEach(([, cValue]) => {
      if (!this.firstError) {
        // eslint-disable-next-line prefer-destructuring
        this.firstError = cValue[0];
      }
    });
  }

  get textProvider(): TextLocalization {
    const language = this.language === undefined ? 0 : this.language;
    return this.textLocalizations[language];
  }

  get resendButtonCaption(): string {
    const sendingText = this.textProvider.thankYouScreen!.resendButtonCaptionSending;
    const defaultText = this.textProvider.thankYouScreen!.resendButtonCaption;
    return (this.isSending) ? sendingText : defaultText;
  }

  get formButtonName(): string {
    const requestingText = this.textProvider.formScreen!.buttonStates.requesting;
    const defaultText = this.textProvider.formScreen!.buttonStates.normal;
    return (this.isSending) ? requestingText : defaultText;
  }

  get isFormShown(): boolean {
    return !this.isTypShown;
  }

  get paragraphWithUsersEmail() {
    return this.textProvider.thankYouScreen!.paragraph2!.replace('{userEmail}', this.userEmail);
  }

  resetErrors() {
    this.errors = {
      // eslint-disable-next-line @typescript-eslint/camelcase
      nwf_fname: false,
      // eslint-disable-next-line @typescript-eslint/camelcase
      nwf_lname: false,
      // eslint-disable-next-line @typescript-eslint/camelcase
      nwf_email: false,
      // eslint-disable-next-line @typescript-eslint/camelcase
      nwf_nsrv: false,
      // eslint-disable-next-line @typescript-eslint/camelcase
      nwf_phone: false,
    };
  }

  submit(form: HTMLFormElement) {
    this.resetErrors();

    document.dispatchEvent(new CustomEvent('form:control'));

    // eslint-disable-next-line no-restricted-globals
    if (location.search.includes('encQryStr') && this.isFirstSend && this.userFormData.nwf_email) {
      this.isSending = false;
      document.dispatchEvent(new CustomEvent('form:lead-ready'));
      document.dispatchEvent(new CustomEvent('email:set', { detail: { email: this.userFormData.nwf_email } }));
      document.dispatchEvent(new CustomEvent('form:user-ready'));
      if (!this.isMobile) {
        this.$emit('has-errors');
      }
      this.isLunchTour = true;
      this.isTypShown = true;
      this.isFirstSend = false;
      this.form = this.$refs.form;
    } else {
      this.isSending = true;
      const formData = new FormData(form);

      formData.append('language', String(this.language));

      axios.post('/form/createLead', formData).then((response) => {
        document.dispatchEvent(new CustomEvent('form:control'));
        document.dispatchEvent(new CustomEvent('form:lead-ready'));

        // Hide errors on first send
        if (!this.isFirstSend) {
          this.isErrorsShown = true;
        }
        this.isFirstSend = false;

        // If errors
        if (response.data.urlRedirectFull === undefined) {
          this.errors = response.data;
          this.isTypShown = false;
          this.$emit('has-errors');
        } else {
          // New user
          if (!response.data.is_active || parseInt(response.data.is_active, 10) === 0) {
            // eslint-disable-next-line no-restricted-globals
            location.href = response.data.urlRedirectFull;
          }

          // Existing User
          if (parseInt(response.data.is_active, 10) === 1) {
            this.isThankYou = false;
            document.dispatchEvent(new CustomEvent('email:set', { detail: { email: this.userFormData.nwf_email } }));
            document.dispatchEvent(new CustomEvent('form:close'));
            document.dispatchEvent(new CustomEvent('app:gaevent'));
            document.dispatchEvent(new CustomEvent('form:user-ready'));
          }
        }

        this.setFirstError();
      }).catch((error) => {
        // eslint-disable-next-line no-console
        console.warn(error);
      }).finally(() => {
        this.isSending = false;
      });
    }
  }

  resendActivationEmail(): void {
    if (!this.isSending) {
      this.isSending = true;
      axios.post('site/ResendRegistrationInfo', {}).catch((error) => {
        // eslint-disable-next-line no-console
        console.warn(error);
      }).finally(() => {
        this.isSending = false;
      });
    }
  }

  setWebDemoId(webDemoId: number) {
    this.webDemoId = webDemoId;
  }

  setProductCode(code: string) {
    this.product = code;
  }

  setLeadComment(name: string) {
    this.leadComment = name;
  }

  setTopicAction(topicAction: string) {
    this.topicAction = topicAction;
  }

  setContentStage(contentStage: string) {
    this.contentStage = contentStage;
  }

  mounted() {
    document.addEventListener('form:change', (e: CustomEventInit) => {
      this.setWebDemoId(e.detail.webDemoId);
      this.setProductCode(e.detail.product);
      this.setLeadComment(e.detail.name);
      this.setTopicAction(e.detail.topicAction);
    });
  }
}
